module.exports = __webpack_public_path__ + "front/img/d10.4352d2f5.png";